export const UserAccumulatedBetActionTypes = {
    FETCH_CURRENT_USER_PICK_START: "FETCH_CURRENT_USER_PICK_START",
    REMOVE_FROM_CURRENT_USER_PICK_START: 'REMOVE_FROM_CURRENT_USER_PICK_START',
    CLEAR_CURRENT_USER_PICK_START: 'CLEAR_CURRENT_USER_PICK_START',
}